import { ReactNode } from "react";
import {
  Info,
  CheckCircle2,
  AlertTriangle,
  AlertCircle,
  LucideIcon,
} from "lucide-react";
import styles from "./Alert.module.css";

type Variant = "info" | "success" | "warn" | "danger";

interface Props {
  variant: Variant;
  title?: string;
  children?: ReactNode;
}

const ICONS: Record<Variant, LucideIcon> = {
  info: Info,
  success: CheckCircle2,
  warn: AlertTriangle,
  danger: AlertCircle,
};

export function Alert({ variant, title, children }: Props) {
  const Icon = ICONS[variant];
  return (
    <div className={`${styles.alert} ${styles[variant]}`} role="alert">
      <span className={styles.icon} aria-hidden="true">
        <Icon size={16} />
      </span>
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        {children && <div className={styles.body}>{children}</div>}
      </div>
    </div>
  );
}
